<template lang="pug">
.v-sidebar.sidebar(v-if="product")
	.sidebar__wrapper
		.sidebar__top
			.product__main(v-if="product.rate || product.price || product.tradingForecast || product.deliveryPrice || product.priceCustoms " )
				.product__prices(v-if="product.rate || product.tradingForecast")
					.product__price(v-if="product.rate")
						v-price(:price="product.rate" view="black" view2="rate" size="sm")
					.product__price(v-if="product.tradingForecast")
						v-price(:price="product.tradingForecast" view="black" size="sm")
				.product__prices(v-if="product.price")
					.product__price(v-if="product.price")
						v-price(:price="product.price" view="green" @open-details="openDetails")
				.product__prices.product__prices--delivery(v-if="product.deliveryPrice")
					.product__price
						v-price(:price="product.deliveryPrice" view="delivery" @open-details="openDetails")
				.product__prices(v-if="product.priceCustoms")
					.product__price
						v-price(:price="product.priceCustoms" view="big" @open-details="openDetails")
						.product__price-flag(v-if="product.priceCustoms.flag" )
							v-svg-icon.tariffs__point-label.tariffs__point-label--on(icon="point-label-on")
							.product__price-flag__text {{product.priceCustoms.flag}}
			.sidebar__customs-calculator(v-if="product.calculatorCustoms")
				button.details__calculator-btn.btn.btn--block(type="button"
						:aria-label="product.calculatorCustoms.ariaLabel || 'Таможенный калькулятор'"
						@click="openCustomsCalculator")
					v-svg-icon.btn__icon(icon="calculator")
					.btn__text {{product.calculatorCustoms.ariaLabel || 'Таможенный калькулятор'}}
			.sidebar__product-payment(v-if="product.payment")
				.sidebar__product-payment-container
					.sidebar__product-payment-title-wrapper
						.sidebar__product-payment-title-left
							v-svg-icon.sidebar__product-payment-icon(icon="payment")
							.sidebar__product-payment-text {{product.payment.text}}
						.sidebar__product-payment-value-wrap
							.sidebar__product-payment-value {{product.payment.value}}
							.sidebar__product-payment-postfix {{product.payment.postfix}}
					button.sidebar__product-payment-btn.btn.btn--lg.btn--product.btn--white(@click.stop="openDetails") Рассчитать
			.sidebar__product-label(v-if="product.label")
				v-svg-icon.sidebar__payment-icon(icon="watch-icon")
				.sidebar__label-text {{product.label}}
			.sidebar__top-btns
				template(v-if="product.btns && product.btns.length"
						v-for="(btn, btnIndex) in product.btns"
						:key="btnIndex")
					button.btn.btn--lg.btn--block.btn--product(
							:class="btn.className || ''"
							:aria-label="btn.text"
							@click.stop="openModal(product.id)")
						| {{btn.text}}
				button.btn.btn--lg.btn--product.btn--block.btn--primary(@click.stop="openModal(product.id)") Связаться
		.sidebar__bottom
			template(v-if="product.footer && product.footer.length"
					v-for="(item, itemIndex) in product.footer"
					:key="itemIndex")
				button.sidebar__btn-wrapper(@click="item.type === 'form' ? openModal(product.id, item.detail || 'history') : (item.type === 'button' ? scrollToField() : null)"
						:aria-label="item.title")
					.sidebar__btn-left
						v-svg-icon.sidebar__btn-icon(:icon="item.icon")
						.sidebar__btn-description
							.sidebar__description-top(v-if="item.title" ) {{item.title}}
							.sidebar__description-bottom(v-if="item.text"
									:class="item.className || ''")
								| {{item.text}}
					.sidebar__btn-right
						.sidebar__right-text(v-if="item.sideText" ) {{item.sideText}}
						v-svg-icon.sidebar__right-icon(icon="pointer-right")
			.sidebar__bottom-text(v-if="product.bottomText" lang="ru") {{product.bottomText}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller.js';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			product: null
		};
	},

	methods: {
		openModal(productId = null, detail = null) {
			controller.openModal({
				className: 'modal--sm',
				component: {
					name: 'v-form',
					props: {
						dataSource: detail === 'history' ? this.product.formHistory : (detail === 'cheaper' ? this.product.formCheaper : this.product.form),
						productId,
						detail,
						media: this.product.media,
						phones: this.product.phones,
						className: 'call-back'
					}
				}
			});
		},

		openDetails(e) {
			e.preventDefault();
			let isButton = e.target instanceof HTMLButtonElement;
			let priceValue = 0;
			let priceCustomsValue = 0;
			if (this.product.price && this.product.price.second && this.product.price.second.value) {
				priceValue = this.product.price.second.value;
			}
			if (this.product.priceCustoms && this.product.priceCustoms.second && this.product.priceCustoms.second.value) {
				priceCustomsValue = this.product.priceCustoms.second.value;
			} else if (this.product.rate && this.product.rate.current && this.product.rate.current.value) {
				priceCustomsValue = this.product.rate.current.value;
			}
			if (this.product.rate && this.product.rate.current) {
				priceValue = this.product.rate.current.value;
			}
			let productData = {
				id: this.product.id,
				price: priceValue,
				priceCustoms: priceCustomsValue,
				options: this.product.options,
				addOptions: this.product.addOptions,
				total: this.product.total,
				year: this.product.year,
				customsCalculator: this.product.customsCalculator,
				engineType: this.product.engineType,
				engineVolume: this.product.engineVolume,
				bid: this.product.bid,
				auctionType: this.product.auctionType,
				stateDelivery: this.product.stateDelivery,
				lemonService: this.product.lemonService,
				enginePower: this.product.enginePower,
				carAge: this.product.carAge,
				carEngine: this.product.carEngine,
				benefit: this.product.benefit,
				country: this.product.country,
				currency: this.product.currency
			};
			if (isButton) {
				controller.openModal({
					className: 'modal--sm credit',
					component: {
						name: 'v-financing',
						props: {
							propProductData: productData,
							dataSource: this.product.creditDetails,
							productId: this.product.calculatorId
						}
					}
				});
			} else {
				controller.openModal({
					className: 'modal--sm',
					component: {
						name: 'v-details',
						props: {
							propProductData: productData,
							dataSource: this.product.formDetails
						}
					}
				});
			}
		},

		scrollToField() {
			let $field = document.querySelector('#questions');
			if ($field) {
				$field.scrollIntoView({
					behavior: 'smooth'
				});
			}
		},

		openCustomsCalculator() {
			controller.openModal({
				className: 'modal--sm',
				btnBackDataSource: (this.product && this.product.formDetails)
					? this.product.formDetails
					: null,
				component: {
					name: 'v-details',
					props: {
						propProductData: this.product,
						view: this.product.formDetails ? "regular" : "customs-calculator",
						withoutBackArrow: true,
						dataSource: this.product.formDetails || this.product.customsCalculator
					}
				}
			});
		},

		dataSet(data) {
			this.product = data;
		}
	}
};
</script>